import { Provider, Type } from '@angular/core';
import { AbstractListViewService } from '@y42/core/list-view';
import { FeatureListViewData } from './abstract-feature-list-view.service.model';

export abstract class AbstractFeatureListViewService<
  T extends FeatureListViewData = FeatureListViewData,
> extends AbstractListViewService<T> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(store: any, protected readonly service: { setActive: (active: string | null) => void }) {
    super();
    // when we go back to list-view from detail-view
    // we need to set active entity to null
    this.service.setActive(null);
  }

  abstract toggleStarred(id: T['id']): Promise<void>;
  abstract saveTags(id: T['id'], tags: string[]): Promise<void>;
  abstract saveDescription(id: T['id'], description: string, level?: number): Promise<void>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function provideFeatureListView(service: Type<AbstractFeatureListViewService<any>>): Provider {
  return [
    service,
    {
      provide: AbstractListViewService,
      useExisting: service,
    },
    {
      provide: AbstractFeatureListViewService,
      useExisting: service,
    },
  ];
}
